import { render, staticRenderFns } from "./Remitent.vue?vue&type=template&id=6746b9fd&"
import script from "./Remitent.vue?vue&type=script&lang=js&"
export * from "./Remitent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports